import type { ProductHighlight } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";

interface ProductCompliancePanelProps {
  locale: PepLocale;
  /** Scrubbed highlights related to compliance / local context. */
  highlights: ProductHighlight[];
  title?: string;
  lead?: string;
  fallbackPoints?: string[];
}

export function ProductCompliancePanel({
  locale,
  highlights,
  title,
  lead,
  fallbackPoints,
}: ProductCompliancePanelProps) {
  const points =
    highlights.length > 0
      ? highlights.slice(0, 3).map((h) => ({
          title: locale === "en" && h.titleEn ? h.titleEn : h.titleFr,
          body: locale === "en" && h.descriptionEn ? h.descriptionEn : h.descriptionFr,
        }))
      : (fallbackPoints ?? []).map((p) => ({ title: p, body: "" }));

  if (!points.length) return null;

  const heading =
    title ??
    (locale === "en"
      ? "Aligned with DRC school operations"
      : "Aligné sur le fonctionnement scolaire en RDC");
  const leadText =
    lead ??
    (locale === "en"
      ? "Built for local school vocabulary, report cards, and EDUSER-oriented workflows — without unofficial seals."
      : "Pensé pour le vocabulaire scolaire local, les bulletins et les flux orientés EDUSER — sans sceau institutionnel non autorisé.");

  return (
    <aside className="pep-pd-compliance" aria-labelledby="pep-pd-compliance-title">
      <h2 id="pep-pd-compliance-title" className="pep-pd-compliance__title">
        {heading}
      </h2>
      <p className="pep-pd-compliance__lead">{leadText}</p>
      <ul className="pep-pd-compliance__list">
        {points.map((p) => (
          <li key={p.title}>
            <span className="pep-pd-compliance__check" aria-hidden>
              ✓
            </span>
            <div>
              <strong>{p.title}</strong>
              {p.body ? <p>{p.body}</p> : null}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
}
